// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__34-UU","card":"Cards_card__1GpFs","infected":"Cards_infected__2Hh7G","recovered":"Cards_recovered__3SgUq","deaths":"Cards_deaths__3Xe8A"};